'use strict'

module.exports = {
  GRID: 'gridRole',
  DROPDOWN_OPTIONS: 'dropdownOptionsRole',
  GALLERY: 'galleryRole',
  UPLOAD_BUTTON: 'uploadButtonRole',
  DETAILS_DATASET: 'detailsDatasetRole',
  REPEATER: 'repeaterRole',
  PAGINATION: 'paginationRole',
  DETAILS_REPEATER: 'detailsRepeaterRole',
  PAGE: 'pageRole'
}



// WEBPACK FOOTER //
// ./componentRoles.js